const extractProductsWithText = (message) => {
  const regex = /<product stacklineSku="([^"]+)">([^<]*)<\/product>/g;
  const products = [];
  let match;
  while ((match = regex.exec(message)) !== null) {
    products.push({
      stacklineSku: match[1],
      innerText: match[2]
      // Can be empty string now
    });
  }
  return products;
};
const extractProductGroups = (message) => {
  const regex = /<product_group>([\s\S]*?)<\/product_group>/g;
  const groups = [];
  let match;
  while ((match = regex.exec(message)) !== null) {
    const fullMatch = match[0];
    const groupContent = match[1];
    const startIndex = match.index;
    const endIndex = match.index + fullMatch.length;
    const products = extractProductsWithText(groupContent);
    groups.push({
      fullMatch,
      startIndex,
      endIndex,
      products
    });
  }
  return groups;
};
export {
  extractProductGroups,
  extractProductsWithText
};
//# sourceMappingURL=StringUtils.js.map
